import axios from 'axios';
import { useEffect, useState } from 'react'
import Box from 'elements/Box';
import { Button, CircularProgress, IconButton, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {ProjectConfig} from 'Global';
import moment from 'moment';
import AlertDialog from 'elements/AlertDialog';
import { useSnackbar, withSnackbar } from 'notistack';

const UserList = () => {

  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false); 
  const [user_list, setUserList] = useState<any []>([]);
  const [total_pages, setTotalPages] = useState(0);

  const queryParams = new URLSearchParams(window.location.search);
  const currentPage=parseInt(localStorage.getItem('page') || "1");

  const [page, setPage] = useState(currentPage);
  const category = queryParams.get('category');
  const [refreshList, setRefreshList] = useState(0);
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');

  useEffect(() => {
    const timeout = window.setTimeout(() => {
      setDebouncedSearch(search.trim());
    }, 300);

    return () => window.clearTimeout(timeout);
  }, [search]);


  /*=========================================================
  LOAD LIST            
  =========================================================*/

  useEffect(() => {
      setLoading(false);

      axios.get(ProjectConfig.api_url,
      {
        params: {
          request: 'user_list',
          page: page,
          search: debouncedSearch,
        }
      })
        .then((response) => {
          console.log("ul ",response.data); 
          setUserList(response.data.user_list)
          setTotalPages(response.data.total_pages)
          setLoading(true)
           
        })
        .catch((err) => {
          console.log(err.data);
          setLoading(true);
        })
        localStorage.setItem('page', page.toString())
    
  }, [page, refreshList, debouncedSearch])
  /*=========================================================*/



  /*=========================================================
  DELETE ITEM
  =========================================================*/

  const handleDelete = (user_id:number) => {
    setActiveItem(user_id)
    setOpenAlert(true)
  }

  const deleteItem = async () => {
    if (!activeItem) {
      return;
    }

    try {
      const response = await axios.post(ProjectConfig.api_url, null, {
        params: {
          request: 'delete_user',
          user_id: activeItem,
        }
      });

      const payload = response.data;

      if (!payload || payload.status !== 'success') {
        throw new Error(
          payload?.message || 'No fue posible eliminar el usuario.'
        );
      }

      setUserList((current) =>
        current.filter((user) => user.user_id !== activeItem)
      );
      setRefreshList((current) => current + 1);
      enqueueSnackbar('Usuario eliminado correctamente', {
        variant: 'success',
      });
    } catch (err: any) {
      console.error('Error eliminando usuario:', err);
      enqueueSnackbar(
        err?.response?.data?.message ||
          err?.message ||
          'No fue posible eliminar el usuario.',
        { variant: 'error' }
      );
    } finally {
      setOpenAlert(false);
      setActiveItem(null);
    }
  }

  
  /*=========================================================*/

// call global snackbar
  
  const [openAlert, setOpenAlert] = useState(false);
  const [activeItem, setActiveItem] = useState<any>(null);
  
  return (
    <div id='ProductList'>
      
      <div className='buttons_top'>
        <Button component={Link} to="add" variant="contained">
          Nuevo usuario
        </Button>

        <input
          type="text"
          value={search}
          style={{
            fontSize: '12px',
            textAlign: 'left',
            width: '240px',
          }}
          placeholder="Buscar por nombre o correo"
          onChange={(event) => {
            setSearch(event.target.value);
            setPage(1);
          }}
        />

      </div>
        <div id="task_list_container" className="flex_container">
          
            <Box id='user_list' title="Usuarios" subtitle="Lista"  >
            {!loading && <div id='loader'><CircularProgress /></div>}
            <TableContainer>
            <Table stickyHeader aria-label="sticky table"> 
              <TableHead>
                <TableRow>
                  <TableCell>Nombre completo</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                  {user_list.map((user,i) => (
                    <TableRow 
                      
                      key={i}
                      hover
                      role="checkbox"
                    >
                      <TableCell onClick={() => navigate(`/admin/usuarios/edit/${user.user_id}`, { state: { user } })}>{user.name}</TableCell>

                     
                      <TableCell>
                        {user.email}
                      </TableCell>

                      <TableCell> 
                        <IconButton aria-label="delete"  color="primary" onClick={() => handleDelete(user.user_id)}>
                          <DeleteOutlineOutlinedIcon />
                        </IconButton>
                    </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          
          <Pagination count={total_pages} page={page}  onChange={(event, value) => {
            setPage(value)
          }
          } 
          color="primary"
          style={{"marginTop": "20px","alignSelf": "center"}}
          />
          </Box>
 
        </div>

        <AlertDialog
            open={openAlert}
            setOpen={setOpenAlert}
            subtitle="¿Está seguro que desea eliminar este usuario?"
            send={deleteItem}
        />
    </div>
  );
};



export default withSnackbar(UserList);